const gccsSettingsBillingHistory = {
  template: require('./template.html'),
  controller: 'SettingsBillingHistoryController',
  controllerAs: 'settingsBillingHistoryCtrl'
};

angular.module('public.security-manager.settings').component('gccsSettingsBillingHistory', gccsSettingsBillingHistory);
